<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">キャンセル規定</li>
    </ol>
  </nav>
  <div class="container">
      <div class="top--section">
        <CancelPolicy/>
      </div>
  </div>
</template>
<script setup lang="ts">
import CancelPolicy from '@/components/Static/CancelPolicy.vue'
</script>